import React from 'react'
import { ZdsProvider } from '@zera/components'
import { MessageCenterProvider, PatientProvider, CacheProvider, LoggedInUserProvider } from '~/context'
import { User } from '~/interfaces'
import { GlobalStyles, theme } from '~/styles'

interface ICommonProviderProps {
  children: React.ReactNode
  user?: User
}

const CommonProviders: React.FC<ICommonProviderProps> = ({ children, user }: ICommonProviderProps): JSX.Element => {
  return (
    <CacheProvider>
      <ZdsProvider theme={theme}>
        <GlobalStyles />

        <MessageCenterProvider>
          <LoggedInUserProvider sessionData={user}>
            <PatientProvider>{children}</PatientProvider>
          </LoggedInUserProvider>
        </MessageCenterProvider>
      </ZdsProvider>
    </CacheProvider>
  )
}

export { CommonProviders }
